export const RESET_APP = "RESET_APP";
export const SET_CONFIG = "SET_CONFIG";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const FAILED_APP = "FAILED_APP";
export const SET_STEPS = "SET_STEPS";
export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const NEXT_STEP = "NEXT_STEP";
export const SET_ENABLE_BTN = "SET_ENABLE_BTN";
export const SET_DISABLE_BTN = "SET_DISABLE_BTN";
export const SET_RETURNED_VALUE = "SET_RETURNED_VALUE";
export const RESET_RETURNED_VALUE = "RESET_RETURNED_VALUE";
export const SET_FIELD_DATA = "SET_FIELD_DATA";
export const ADD_SUB_STEP = "ADD_SUB_STEP";
export const REPLACE_SUB_STEP = "REPLACE_SUB_STEP";
export const DELETE_SUB_STEP = "DELETE_SUB_STEP";
export const SET_STEP_BY_PASS = "SET_STEP_BY_PASS";
export const STEP_REMOVE_CHILDREN = "STEP_REMOVE_CHILDREN";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_MESSAGE_WITH_CODE = "SET_MESSAGE_WITH_CODE";
export const RESET_MESSAGE_WITH_CODE = "RESET_MESSAGE_WITH_CODE";
export const SET_FETCHER_URLS = "SET_FETCHER_URLS";
export const SET_FETCHER_APPOINTMENT = "SET_FETCHER_APPOINTMENT";
export const SET_ITEM_BREADCRUMBS = "SET_ITEM_BREADCRUMBS";
export const EMPTY_BREADCRUMBS = "EMPTY_BREADCRUMBS";
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const ALERT_DIALOG = "ALERT_DIALOG";
export const SHOW_FAQ = "SHOW_FAQ";
export const SHOW_DIALOG_SMS = "SHOW_DIALOG_SMS";
export const FAQ = "FAQ";
export const CGU = "CGU";
export const USER_KEY = "USER_KEY";
export const SET_PRACTITIONERS = "SET_PRACTITIONERS";
export const USER_AREA = "USER_AREA";
export const ADD_USER_SELECTED = "ADD_USER_SELECTED";
export const REMOVE_USER_SELECTED = "REMOVE_USER_SELECTED";
export const RESET_USERS_SELECTED = "RESET_USERS_SELECTED";
export const CLOSE_MAIN_DIALOG = "CLOSE_MAIN_DIALOG";
export const CODE_SMS = "CODE_SMS";
export const SHOW_BTN_NEXT = "SHOW_BTN_NEXT";
export const TO_VALIDATE_TOKEN = "TO_VALIDATE_TOKEN";
export const USER_DATA = "USER_DATA";
export const RESET_USER_DATA = "RESET_USER_DATA";
export const ALERT_GO_TO_BEGINNING = "ALERT_GO_TO_BEGINNING";
export const ALERT_GO_TO_NEXT = "ALERT_GO_TO_NEXT";

export const LOCALE_ADD_CATALOG = "LOCALE_ADD_CATALOG";
export const LOCALE_SET_LANGUAGE = "LOCALE_SET_LANGUAGE";
export const IS_PATIENT_AREA = "IS_PATIENT_AREA";
export const MY_APPOINTMENTS = "MY_APPOINTMENTS";
export const LINKED_ACCOUNTS = "LINKED_ACCOUNTS";
export const HISTORY = "HISTORY";
export const FILES_DOWNLOAD = "FILES_DOWNLOAD";
export const FILES = "FILES";
export const ORIGIN_QR_CODE = "ORIGIN_QR_CODE";
export const LIST_PATIENT = "LIST_PATIENT";
export const ALL_INFO_USER = "ALL_INFO_USER";
export const ALL_INFO_WAITING_ROOM = "ALL_INFO_WAITING_ROOM";
export const IS_FIRST_CONNEXION_WIDGET_PATIENT =
  "IS_FIRST_CONNEXION_WIDGET_PATIENT";

export const SECRET_UPDATE = "SECRET_UPDATE";
export const DETAIL_PATIENT = "DETAIL_PATIENT";
export const PAYMENT = "PAYMENT";
export const DETAIL_PAYMENT = "DETAIL_PAYMENT";
export const IS_VALID_SOCIAL_SECURITY = "IS_VALID_SOCIAL_SECURITY";
export const SHOW_CODE_PRIORITAIRE = "SHOW_CODE_PRIORITAIRE";
export const DATE_SURVEY = "DATE_SURVEY";

export const INFO_FOR_STATUS_FORM_FIELD = "INFO_FOR_STATUS_FORM_FIELD";

export const CONTINUE_HANDLE_FOOTER = "CONTINUE_HANDLE_FOOTER";
export const SHOW_FOOTER_CONTINUE = "SHOW_FOOTER_CONTINUE";
export const SET_APP_URL = "SET_APP_URL";
export const MY_PARAMS = "MY_PARAMS";
